module.exports = __webpack_public_path__ + "img/filter.10fef6c3.svg";